import React from 'react';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-[#f4ece1]" data-id="element-67">
      <div className="max-w-2xl mx-auto text-center" data-id="element-68">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-sm mb-6 text-brand-gold" data-id="element-69">
          <Shield className="w-8 h-8" data-id="element-70" />
        </div>

        <h2 className="text-2xl md:text-3xl font-black text-brand-text mb-6 uppercase tracking-wide" data-id="element-71">
          GARANTÍA DE DEVOLUCIÓN DE TU DINERO
        </h2>

        <p className="text-brand-gray mb-6 leading-relaxed text-lg" data-id="element-72">
          Tienes 7 días de garantía sin preguntas. Si el material no cumple tus
          expectativas, te devolvemos el 100% de tu dinero. Solo envíanos un
          email.
        </p>
      </div>
    </section>;
}